let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lqf4p")).then(() => parcelRequire('2DoLm'));